import { kuiperClassNames } from '@opallabs/kuiper'
import { Icon, Tooltip } from '@opallabs/lapidary'

import './styles.scss'

type PartialMoment = {
  primaryStory?: {
    name: string
    color: string
  }
  isPrivate?: boolean
  storyNames?: string[]
}

export const TooltippedStoryHeading: React.FC<{ moment: PartialMoment }> = ({
  moment,
}) => {
  const storyNames =
    Array.isArray(moment.storyNames) && moment.storyNames.length > 1
      ? moment.storyNames.join(', ')
      : ''

  if (!moment.primaryStory) return null

  const title = moment.primaryStory.name
  const color = moment.primaryStory.color
    ? `#${moment.primaryStory.color}`
    : '#6F7D8A'
  const storyCount =
    Array.isArray(moment.storyNames) && moment.storyNames.length > 1
      ? moment.storyNames.length
      : null

  return (
    <Tooltip
      disabled={!storyNames}
      content={storyNames}
      side="top"
      zIndex={999}
    >
      <div className={kuiperClassNames('storyHeading')}>
        <div className={kuiperClassNames('storyHeading-counterAndIcon')}>
          {storyCount ? (
            <div className={kuiperClassNames('storyHeading-counter')}>
              {storyCount}
            </div>
          ) : null}
          <Icon
            ariaMode="hidden"
            color={color}
            glyph="story"
            height={14}
            width={14}
            useHypernova={true}
          />
        </div>
        <div className={kuiperClassNames('storyHeading-title')}>{title}</div>
        {moment.isPrivate && (
          <Icon
            ariaMode="hidden"
            color="#a0aeb9"
            glyph="private"
            height={14}
            width={14}
            styleOverrides={{
              container: { marginLeft: 4 },
            }}
            useHypernova={true}
          />
        )}
      </div>
    </Tooltip>
  )
}
